import constants from 'constants';
const {
  ADD_SUBSCRIPTIONS,
  JOIN_WEBINAR_FROM_LINK_SAGA,
  JOIN_WEBINAR_FROM_QR_SAGA,
  // LOAD_WEBINAR_SUBSCRIPTION
} = constants;

export const addSubscriptions = (subscriptions) => ({
  type: ADD_SUBSCRIPTIONS,
  subscriptions
})

// export const loadWebinarSubscription = (subscriptionEvent) => ({
//   type: LOAD_WEBINAR_SUBSCRIPTION,
//   subscriptionEvent
// })

export const joinWebinarFromLinkSaga = (webinarId) => ({
  type: JOIN_WEBINAR_FROM_LINK_SAGA,
  webinarId
})

export const joinWebinarFromQRSaga = (webinarId) => ({
  type: JOIN_WEBINAR_FROM_QR_SAGA,
  webinarId
})



// WEBPACK FOOTER //
// ./src/actions/subscriptions.js